import { App } from 'antd';
import type { ReactElement } from 'react';
import type { MessageInstance } from 'antd/es/message/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';
import type { NotificationInstance } from 'antd/es/notification/interface';

let message: MessageInstance;
let notification: NotificationInstance;
let modal: Omit<ModalStaticFunctions, 'warn'>;

/**
 * 处理反馈组件的静态方法 message，modal，notification（这个组件要放在App组件下）
 */
function Feedback(): ReactElement | null {
  const staticFunction = App.useApp();
  /* eslint-disable prefer-destructuring*/
  message = staticFunction.message;
  modal = staticFunction.modal;
  notification = staticFunction.notification;

  return null;
}

export { Feedback, message, notification, modal };
